import { SIDEBAR_COLORS } from "@lhd/constants";
import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  left: 0;
  z-index: 1000;
  height: auto;
`;

export const Styles = styled.div<{
  columnGap: number;
  isNewTab?: boolean;
  isMobile?: boolean;
}>`
  padding: 8px 24px 8px 0px;
  background: #fff;
  display: flex;
  height: 48px;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => (props.isMobile ? "#192a4d" : "#E7E8E7")};

  .org-name {
    color: #fff;
    margin-left: 6px;
  }

  .avatar {
    width: 40px;
    height: 40px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
    }
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    & a {
      color: #fff;
    }
    & h4 {
      color: #fff;
    }

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  h3 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 0;
    color: #1e3666;
  }

  h4 {
    margin-bottom: 0;
    margin-top: -3px;
    font-size: 1.3rem;
  }

  svg {
    color: #1e3666;
    // margin-left: 10px;
  }

  .container-breadcumb {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    column-gap: ${(props) => props.columnGap}px;

    .logo-detail-collapse {
      transition: 0.1s;
      display: flex;
      align-items: center;
      width: ${(props) => (props.isNewTab ? "238px" : "300px")};
      justify-content: space-between;
      margin-left: 8px;
    }
    .logo-detail-un-collapse {
      margin-left: -1px;
      margin-right: 0;
      transition: 0.1s;
    }
    button {
      &.btn-back {
        background: #1e3665;
        border: 1px solid #ffffff;
        color: #ffffff;
        width: 40px;
        min-width: 40px;
        height: 40px;
        margin-right: 8px;
        border-radius: 4px;
        font-size: 8px !important;
        line-height: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        padding: ${(props) =>
          props.isMobile ? "0px 8px !important " : "0px 4px !important"};
      }

      &.active {
        background: ${SIDEBAR_COLORS.CUSTOMER_BG};
        color: #fff;
      }
    }
  }

  .wrap-breadcumb {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex: 1;
    padding-left: 4px;
    display: flex;

    .wrap-breadcrumb-item {
      display: flex;
    }

    .wrap-breadcrumb-image {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 100;
      padding-bottom: 4px;

      &-large {
        font-size: 20px;
        padding-bottom: 0;
        //color: rgba(255, 255, 255, 0.55);
      }

      & svg {
        margin: 0;
      }
    }

    .breadcrumb-item {
      padding: 0 12px;
      font-size: 14px;
      display: inline;
      overflow: hidden;
      text-overflow: ellipsis;

      &.margin-top-default-btn {
        margin-top: 2px;
        p {
          font-weight: 600;
        }
      }

      &.border-none {
        border: none !important;
      }
      &.background-none {
        background-color: transparent !important;
      }

      &.breadcrumb-item-in-active {
        background-color: var(--inactive-color);
        font-weight: 500;
        display: flex;
        align-items: center;
        a,
        p {
          font-size: 14px;
          line-height: 20px;
          color: #333333;
          //font-weight: 600;
        }

        &:not(.background-none) {
          background-color: #d9dde5 !important;
          a,
          p {
            margin-top: 2px;
          }
        }
      }
      &.breadcrumb-item-active {
        background-color: #d9dde5 !important;
        border-top: 4px solid #1e3665 !important;
        border-bottom: 4px solid transparent !important;
        font-weight: bold;
        height: 30px;
        a,
        p {
          font-weight: bold !important;
          font-size: 14px;
          line-height: 20px;
          color: #1e3665 !important;
        }
      }

      &:last-child > a {
        color: #ffffff;
      }

      & a {
        color: #d9dde5;
      }

      & p {
        color: rgba(0, 0, 0, 0.45);
        display: inline;
        cursor: default;

        &.clickable {
          cursor: pointer;
        }
      }
    }
  }
  .container-avatar {
    margin-left: 10px;
  }

  .notification-icon {
    margin-right: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    position: relative;

    &:hover {
      opacity: 0.8;
    }

    .ant-badge {
      .ant-badge-count {
        position: absolute;
        top: 4px;
        right: 4px;
        background-color: #ff4d4f;
        box-shadow: 0 0 0 1px #fff;
      }
    }
  }

  .notification-popover-overlay {
    margin-top: -30px !important;

    .ant-popover-inner {
      padding: 0 !important;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .ant-popover-inner-content {
      padding: 0 !important;
    }

    /* Style arrow to be larger and closer to popover */
    .ant-popover-arrow {
      margin-top: -23px !important;
      transform: translateX(-2px);
      &::before,
      &::after {
        background: #fff !important;
      }
    }

    &.ant-popover-placement-bottomRight {
      .ant-popover-arrow {
        right: 14px !important;
        left: auto !important;
      }
    }
  }
  .header-new-tab {
    display: flex;
    align-items: center;
    column-gap: 6px;
    img {
      width: 34px;
      height: 34px;
    }
  }

  .button-work-end {
    font-size: 14px;
    height: 30px !important;
    color: white;
    background-color: var(--danger-color);
    border: 0;
    cursor: pointer;
    padding-inline: 8px;
    border-radius: 0px;
  }
`;

export const StylesModalSelectEdit = styled.div`
  width: 100%;

  .group-button {
    display: flex;
    justify-content: center;

    & button {
      margin-right: 10px;
    }
  }
`;

export const CompanyNameWrapper = styled.div<{
  $isTwoLines: boolean;
  $isNewTab?: boolean;
}>`
  font-weight: 600;
  font-size: ${(props) => (props.$isTwoLines ? "12px" : "16px")};
  text-align: center;
  color: ${(props) => (props?.$isNewTab ? "#ffffff" : "#1E3665")};
  cursor: pointer;
  max-width: 211px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  padding-bottom: 8px;
  align-items: end;
  justify-content: center;
  height: 48px;
  margin-left: 4px;
  line-height: 1;
  transition: 0.1s;
`;
